export default {
  // 学生注册
  nameZh: '中文名',
  nameEN: '英文名',
  lastName: '姓(拼音形式)',
  firstName: '名(拼音形式)',
  gender: '性别',
  female: '女',
  male: '男',
  title: '称谓',
  birthday: '出生日期',
  phoneNumber: '学生联系电话',
  phoneRegion: '区号',
  account: '账号',
  email: '电子邮件',
  emailTips:'【重要:请确保邮箱准确，可以正常接收邮件，否则会影响申请的进度】',
  emailPassword: '电子邮件密码',
  country: '国家/地区',
  state: '省',
  city: '市',
  region: '区',
  postcode: '邮政编码',
  address: '联系地址',
  alternativeAddr: '备选联系地址',
  fillApply: '保存并填写入学申请',
  returnStuList: '返回列表',
  fkAreaRegion: '区域',
  saveTemporal: "信息待完善，暂存",
  moreEmailTips:' (多个邮箱请用(;+空格)隔开)',
  viewStudentsAddApplications:'查看学生并进行加申操作',
  duplicateStudentTips:'检测到，重复学生有{num}个！',
  viewStudentsEditThem:'查看学生并进行编辑操作',
  shareLink:'共享链接',
  notStudentEmail:'(非学生电邮)',

  // 学生资料管理
  isLivedSinceBirth: '是否自出生便在这个国家/地区居住？',
  fkStudentAppCountryIdLive: '目前所在国家/地区',
  migrationTime: '移居时间',
  stayingRightTime: '取居留权时间',
  isHavePassport: '是否有护照',
  fkStudentAppCountryIdPassport: '签发国家/地区',
  passportIssueDate: '签发日期',
  passportIssueExpried: '有效期至',
  passportNumber: '护照号码',
  followUpPhoneCode: '区号',
  followUpPhoneNumber1: "跟进联系人电话号码1",
  followUpPhoneCode1: '区号1',
  followUpEmail1: '跟进人电邮1',
  followUpPhoneNumber2: "跟进联系人电话号码2",
  followUpPhoneCode2: '区号2',
  followUpEmail2: '跟进人电邮2',
  followUpPhoneNumber3: "跟进联系人电话号码3",
  followUpPhoneCode3: '区号3',
  followUpEmail3: '跟进人电邮3',
  passportInfo: '护照信息',
  contactPerson: '联系负责人',
  contactNotice: '(建议提供顾问老师手机号码，以便收取系统推送学生个案进展)',
  atLeastOne: '(至少填写一个)',
  fkStudentAppCountryId: '学生国籍/地区',
  fkStudentAppAncestryId: '学生血统',
  fkStudentAppMotherLanguageId: '学生母语',
  fkStudentAppCountryIdBirth: '出生国家/地区',
  cityBirth: '出生城市',
  idCardNumber: '身份证',
  idCardNumberTips: '【说明：如学生来自中国内地，需要申请香港大学时，请务必录入身份证号码】',
  whetherPayment:'是否代付',

  regStartTime: '入档开始时间',
  regEndTime: '入档结束时间',
  openTimeStart: '开学开始日期',
  openTimeEnd: '开学结束日期',
  openTime: '开学日期',
  export: '导出',
  applicationStatus: '申请处理状态',
  failureReason: '失败原因',
  regGmtCreate: '入档时间',
  edit: '编辑申请',
  addApplyCourse: '加申课程',
  personInfo: '个人信息',
  applyFollow: '申请跟进情况',
  allDataRegiest: '完整资料注册',
  baseDataRegiest: '注册基本资料',
  intelligentIdentificationStudentInfo: '智能识别学生资料',
  intelligentIdentificationTips: '智能识别通过AI技术图像识别资料',
  intelligentIdentificationTips2_1: '2.如何',
  intelligentIdentificationTips2_2: '上传识别',
  intelligentIdentificationTips2_3: '？点击上方区域上传护照（文件格式为图片或PDF）',
  intelligentTitle: '1.请选择护照国家/地区',
  uploadPassportNational: '上传其他地区护照图片',
  uploadPassport: '上传中国大陆护照图片',
  uploadBackground: '上传背景资料',
  continuetofill: '手动填写',
  continueInput: '继续填写',
  stuName: '姓名（中文）',
  stuNameEn: '姓名（英文）',
  stuGender: '性别',
  stuNation: '民族',
  stuBirth: '出生日期',
  stuIdcard: '身份证',
  stuBirthPlace: '出生地',
  stuPassport: '护照号码',
  stuEduExp: '教育经历',
  stuWorkExp: '工作经历',
  notUpload: '未上传',
  aiCode1:'证件边框不完整,请重新上传',
  aiCode2:'请上传原件',
  aiCode3:'无法时别文件，请重新上传',
  aiCode4:'证件不能修改,请重新上传',
  aiCode5:'证件有反光,请重新上传',
  aiCode6:'证件模糊,请重新上传',
  aiCode7:'告警能力未开通',

  // 文件下载
  studentInformation: '学生资料',

  courseApplyStatus: '申请状态',
  courseApplyStatus0: '新建',
  courseApplyStatus1: '已提交',
  courseApplyStatus2: '补件',
  courseApplyStatus3: '加申',
  courseApplyStatus4: '顾问已提交',
  // 学生资料管理
  student: '学生',
  fkAreaCountryName: '国家/地区',
  schoolName: '学校名称',
  courseName: '课程名称',
  lastBmsApplyFollowStatusName: '课程申请最新状态',
  submitInfoStatus: '资料提交状态',
  editApplyStatus: '修改申请状态',
  completed: '已完成',
  unCompleted: '未完成',
  current: '当前',
  notStart: '未启动',
  // 学生申请汇总
  studentName: '学生姓名',
  studentNameZh: '学生姓名(中)',
  studentNameEn: '学生姓名(英)',
  applySchoolName: '申请学校',
  applyCourseName: '申请课程',
  courseType: '课程类型',
  bmsApplyFollowStatusName: '申请步骤状态',
  applyTotalCount: '申请资料递交总数',
  openingTime: '入学时间（月）',
  notISSUEStudent: '非ISSUE创建学生',
  checkIssueStudentInfo: '查看issue学生信息',
  bindOnlineForm: '绑定在线表单',
  bindSuccess: '绑定成功',
  bindErr: '绑定失败请检查数据',
  inputOnlineForm: '请输入在线表单编号',
  inputOnlineFormErr: '请检查输入格式',
  noSelectTips: '选择不到可进行手写输入',
  batchTransferStudentManagementAccounts:'批量转学生管理帐号',
  createAccount:'创建账号',
  currentManagementAccount:'当前管理账号',
  transferManagementAccount:'转移管理账号',
  transferTips:'学生转移后，当前账号将看不到转移的学生。除非当前账号是转移账号的父级账号。',
  noTransferData:'暂无下属帐号可以选择',
  transferSuccess:'转移成功',
  transferFail:'转移失败',
  
  applyDialogTips1: '您有学生申请待提交 ！',
  applyDialogTips2: '您目前仍有未完成或尚未提交至 GEA 的申请；请查看并完成提交，以便我们继续协助处理。',
  applyDialogTips3: '共',
  applyDialogTips4: '条申请需处理',
  applyDialogTipsButton: '前往处理',
}
